import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import createScript from './createScript';
import createGoogleMap, { withGoogleMap } from './createGoogleMap';

/**
 * @example
 *
 * const DefaultMapContainer = styled.div`
 *   height: 320px;
 *   width: 100%;
 * `;
 *
 * const fitBounds = (trip, map) => {
 *   // do something.
 * }
 *
 * const trip = {
 *   // key: value
 * };
 *
 * <GoogleMap
 *   fitBounds={map => fitBounds(trip, map)}
 *   mapContainer={<DefaultMapContainer />}
 *   defaultCenter={{ lat: 13.736717, lng: 100.523186 }}
 *   defaultZoom={5}
 * />
 */

class GoogleMap extends React.PureComponent {
  static propTypes = {
    map: PropTypes.object,
    fitBounds: PropTypes.func,
    children: PropTypes.node
  }

  static defaultProps = {
    fitBounds: () => {}
  }

  constructor(props) {
    super(props);
    const { map, fitBounds } = props;
    fitBounds(map);
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

export default compose(
  createScript,
  createGoogleMap,
  withGoogleMap,
)(GoogleMap);
